import * as _4 from 'lodash4';

class CalendarPlaceholderAlert {
  private times: any[];
  private close: () => void;
  private term: string;

  constructor(private $state: ng.ui.IStateService) {}
  closePlaceholder() {
    this.close();
  }

  viewPreferences() {
    this.$state.go('my.schedule.registration.preferences');
  }
}

class CalendarPlaceholderAlertComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      times: '<',
      close: '&',
      term: '<'
    };
    this.controller = CalendarPlaceholderAlert;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/calendar_placeholder_alert/calendar_placeholder_alert.html';
  }
}

angular
  .module('capability-ng-scheduler')
  .component('calendarPlaceholderAlert', new CalendarPlaceholderAlertComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/calendar_placeholder_alert/calendar_placeholder_alert.ts